module.exports = __webpack_public_path__ + "static/media/all1.760899c2.jpg";